enum ReportType {
  /** Медосмотр */
  BodyCheck = 'bodyCheck',

  /** Карты рисков */
  RiskMap = 'riskMap',

  /** Архив карт рисков */
  RiskMapReportArchive = 'riskMapReportArchive',

  /** Реестр опасностей */
  RiskMapDanger = 'riskMapDanger',

  /** Средства индивидуальной защиты */
  RiskMapIndividualMean = 'riskMapIndividualMean',

  /** План мер по управлению рисками */
  RiskMapControlMeasurePlan = 'riskMapControlMeasurePlan',

  /** Статистика обучений */
  Employees = 'employees',

  /** Стажировочный лист — %ФИО сотрудника% */
  EmployeeProbationSheet = 'employeeProbationSheet',

  /** Протокол — %Название обучения% */
  EducationDestinationProtocol = 'educationDestinationProtocol',

  /** Журнал первичного/повторного инструктажа */
  MultipleBriefing = 'multipleBriefing',

  /** Ознакомление с картами риска */
  RiskMapEmployeeReview = 'riskMapEmployeeReview',

  /** Должности без карты рисков */
  JobPositionWithoutRiskMap = 'jobPositionWithoutRiskMap',

  /** Положение: система управления рисками */
  ProfessionalRiskManagementSystem = 'professionalRiskManagementSystem',

  /** Реестр Минтруда (xls) */
  MinistryLaborXlsx = 'ministryLaborXlsx',

  /** Реестр Минтруда (xml) */
  MinistryLaborXml = 'ministryLaborXml',

  /** Ссылки для задания паролей сотрудникам */
  EmployeeRecoveryLinks = 'employeeRecoveryLinks',

  /** Журнал вводного инструктажа по охране труда */
  InitialBriefing = 'initialBriefing',

  /** Перечень должностей для инструктажей */
  ConductJobPosition = 'conductJobPosition',

  /** Журнал электробезопасности (I группа) */
  ElectricalSafetyNonElectric = 'electricalSafetyNonElectric',

  /** Журнал противопожарных инструктажей */
  FireSafetyBriefing = 'fireSafetyBriefing',
}

export default ReportType
